import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegendActiveMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_2452_15194)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2452_15194",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 33,
			height: 32,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 32,
				height: 32,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2452_15194)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16.4307 22.1407C16.812 22.1407 17.1338 22.0095 17.396 21.747C17.6585 21.4846 17.7897 21.1628 17.7897 20.7817C17.7897 20.4006 17.6585 20.0788 17.396 19.8163C17.1338 19.5539 16.812 19.4227 16.4307 19.4227C16.0496 19.4227 15.7278 19.5539 15.4653 19.8163C15.2029 20.0788 15.0717 20.4006 15.0717 20.7817C15.0717 21.1628 15.2029 21.4846 15.4653 21.747C15.7278 22.0095 16.0496 22.1407 16.4307 22.1407ZM15.4873 17.3663H17.364C17.3727 17.0312 17.3958 16.7432 17.4333 16.5023C17.4709 16.2612 17.5452 16.027 17.6563 15.7997C17.7675 15.5723 17.9085 15.3531 18.0793 15.142C18.2505 14.9309 18.4787 14.6826 18.764 14.397C19.4736 13.6877 19.9809 13.0847 20.286 12.588C20.5911 12.0916 20.7437 11.5271 20.7437 10.8947C20.7437 9.78512 20.365 8.89067 19.6077 8.21134C18.8503 7.53179 17.8751 7.19201 16.682 7.19201C15.5967 7.19201 14.6689 7.46845 13.8987 8.02134C13.1287 8.57445 12.5812 9.29456 12.2563 10.1817L13.9693 10.869C14.1591 10.3032 14.4745 9.84123 14.9153 9.48301C15.3565 9.12479 15.9095 8.94567 16.5743 8.94567C17.2941 8.94567 17.8561 9.14101 18.2603 9.53168C18.6646 9.92234 18.8667 10.3971 18.8667 10.956C18.8667 11.368 18.7444 11.7723 18.5 12.169C18.2556 12.5655 17.8787 12.9937 17.3693 13.4537C17.0171 13.7648 16.7243 14.066 16.491 14.3573C16.2577 14.6489 16.0632 14.9485 15.9077 15.256C15.7521 15.5638 15.6431 15.8839 15.5807 16.2163C15.5185 16.5488 15.4873 16.9321 15.4873 17.3663ZM16.5 29.7177L12.782 25.9997H7.57701C6.90345 25.9997 6.33334 25.7663 5.86667 25.2997C5.40001 24.833 5.16667 24.2629 5.16667 23.5893V5.74334C5.16667 5.06979 5.40001 4.49967 5.86667 4.03301C6.33334 3.56634 6.90345 3.33301 7.57701 3.33301H25.423C26.0966 3.33301 26.6667 3.56634 27.1333 4.03301C27.6 4.49967 27.8333 5.06979 27.8333 5.74334V23.5893C27.8333 24.2629 27.6 24.833 27.1333 25.2997C26.6667 25.7663 26.0966 25.9997 25.423 25.9997H20.218L16.5 29.7177ZM7.57701 23.9997H13.5923L16.5 26.9073L19.4077 23.9997H25.423C25.5428 23.9997 25.6411 23.9612 25.718 23.8843C25.7949 23.8075 25.8333 23.7091 25.8333 23.5893V5.74334C25.8333 5.62356 25.7949 5.52523 25.718 5.44834C25.6411 5.37145 25.5428 5.33301 25.423 5.33301H7.57701C7.45723 5.33301 7.35889 5.37145 7.28201 5.44834C7.20512 5.52523 7.16667 5.62356 7.16667 5.74334V23.5893C7.16667 23.7091 7.20512 23.8075 7.28201 23.8843C7.35889 23.9612 7.45723 23.9997 7.57701 23.9997Z",
				fill: "white"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2452_15194",
		x: .5,
		y: 0,
		width: 33,
		height: 33,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.112809 0 0 0 0 0.417748 0 0 0 0 0.518555 0 0 0 1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2452_15194"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2452_15194",
				result: "shape"
			})
		]
	}) })]
});
export default SvgLegendActiveMobile;
